module.exports = __webpack_public_path__ + "static/img/Tevita-PangaiJunior.b3329d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tevita-PangaiJunior.jpg
// module id = psq4
// module chunks = 0